import { createAsyncThunk } from '@/redux/createAsyncThunk';
import { fetchCatalogsNearMeByBoundingBox, fetchCatalogsNearMeByCityState } from './catalogsNearMe.api';
import { getDeployment } from '@/redux/modules/config';
import type {
    CatalogsNearMeBoundingBoxRequest,
    CatalogsNearMeCityStateRequest,
    CatalogsNearMeResponse,
} from './catalogsNearMe.types';

/**
 * Fetch catalogs near a location using bounding box coordinates
 * Used when user searches for custom location or moves the map
 * @category Catalog Management API
 */
export const fetchCatalogsNearMeByBounds = createAsyncThunk<CatalogsNearMeResponse, CatalogsNearMeBoundingBoxRequest>(
    'la/domain/auctionsNearMe/fetchByBounds',
    async (params, { getState }) => {
        const state = getState();
        const deployment = getDeployment(state);

        return await fetchCatalogsNearMeByBoundingBox({
            ...params,
            deployment,
        });
    }
);

/**
 * Fetch catalogs near a location using city and state
 * Used when user navigates to SEO-friendly city URL
 * e.g. /find-auctions-near-me/denver/co
 * @category Catalog Management API
 */
export const fetchCatalogsNearMeByCityAndState = createAsyncThunk<
    CatalogsNearMeResponse,
    CatalogsNearMeCityStateRequest
>('la/domain/auctionsNearMe/fetchByCityState', async (params, { getState }) => {
    const state = getState();
    const deployment = getDeployment(state);

    return await fetchCatalogsNearMeByCityState({
        ...params,
        deployment,
    });
});
